import UploadData from "./UploadData";
export default UploadData;
